<template>
  <v-dialog v-model="open" max-width="420" @click:outside="$emit('close')">
    <v-card style="border-radius:12px;">
      <v-card-title style="font-size:15px;font-weight:700;color:#2d3748;padding:16px 16px 8px;">Napomena na račun</v-card-title>
      <v-card-text>
        <v-textarea v-model="text" outlined dense rows="3" label="Upiši napomenu..." clearable auto-grow />
      </v-card-text>
      <v-card-actions style="padding:8px 16px 16px;gap:8px;">
        <v-spacer />
        <v-btn text small @click="$emit('close')">Odustani</v-btn>
        <v-btn small depressed
          style="background:rgba(0,188,212,0.1);color:#00BCD4;border:1px solid rgba(0,188,212,0.3);border-radius:8px;"
          @click="() => { $emit('save', text); $emit('close') }"
        >Spremi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ShopNoteModal',
  props: {
    open: { type: Boolean, default: false },
    note: { type: String, default: '' }
  },
  data () { return { text: '' } },
  watch: {
    note: { immediate: true, handler (v) { this.text = v || '' } }
  }
}
</script>
